import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';

import { Card, CardText, CardTitle } from 'material-ui/Card';
import Divider from 'material-ui/Divider';
import { List, ListItem } from 'material-ui/List';
import DetailView from '../Common/DetailView';

import CallIcon from 'material-ui/svg-icons/communication/call';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

import ContactStore from '../../stores/ContactStore';
import ContactActions from '../../actions/ContactActionCreator';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import { withId } from '../Common/Decorators';

const Contact = React.createClass({

    getInitialState: function () {

        return {
            details: {
                id: '',
                name: '',
                email: '',
                notes: '',
                phoneNumbers: [],
            },
            actions: [],
            menuItems: [
                {
                    link: '/dashboard/contact/' + this.props.id + '/edit',
                    icon: <EditIcon />,
                    label: 'Edit',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
                {
                    type: 'deleteDialog',
                    dialogType: 'menu',
                    value: this.props.id,
                    title: 'Delete ',
                    deleteAction: this._onDelete,
                    message: (
                                <span>
                                    Are you sure you want to delete this contact?
                                </span>
                            ),
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                }
            ],
            links: {
                back: '/dashboard/contacts',
                edit: '',

            }
        }
    },


    componentDidMount: function() {
        ContactStore.addChangeListener(this._onChange);
        ContactActions.getById(this.props.id);

        this.setState(
            assign({},
            this.state, {
                actions: buildContextMenu(this.state.menuItems, this.context.auth)
            }
        ));

    },

    componentWillUnmount: function() {
        ContactStore.removeChangeListener(this._onChange);
    },

    render: function () {
        
        const detailViewProps = {
            title:      'Contact',
            backButton: true,
            backTo:     this.state.links.back,
            actions:    this.state.actions
        };
        
        let notes;
        if (!!this.state.details.notes) {
            notes = <CardText>{this.state.details.notes}</CardText>;
        }
        let contacts;
        let contactList = [];
        if (!!this.state.details.email) {
            contactList.push( <ListItem key="email" leftIcon={<EmailIcon/>} primaryText={this.state.details.email} secondaryText="Email" />);
        }
        this.state.details.phoneNumbers.forEach(function(entry) {
            contactList.push(<ListItem key={entry.id} leftIcon={<CallIcon/>}  primaryText={entry.number}  secondaryText={entry.phoneType} />);
        }, this);
        
        if (contactList.length > 0) {
            contacts = (
                <div>
                    <Divider />
                    <List>
                        {contactList}
                    </List>
                </div>
            );
        }
        return(
            <DetailView {...detailViewProps} >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardTitle title={this.state.details.name} />
                        {notes}
                        {contacts}
                    </Card>
                </div>
            </DetailView>
      );
    },

    _onChange: function(){
        const details = ContactStore.getById(this.props.id);
        if (details !== undefined) {
            this.setState({details: details});
        }
    },

    _onDelete: function(entityId) {
        if (entityId === this.props.id) {
            ContactActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    },

});

Contact.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(Contact);
